import * as XXH from 'xxhashjs';

const MAX_THUMB_SIZE = 4096;
const XXHASH_SEED = 0xF00D; //DO NOT CHANGE - changing this would mismatch all previous hashes

export function getImageHash(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.addEventListener('load', (event: any) => resolve(XXH.h64(event.target.result, XXHASH_SEED).toString(36)));
		reader.onerror = e => reject(e);
		reader.readAsArrayBuffer(file);
	});
}

export function getSVGDataURL(file: File): Promise<{content:string,url:string}> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', (event: any) => {
      const content = event.target.result
      const svg = encodeSVG(content); // get rid of spaces and new lines, etc. to reduce size
      resolve({ content, url:`data:image/svg+xml;utf8,${svg}`});
    });
    reader.onerror = e => reject(e);
    reader.readAsText(file);
  });
}

export function getImageDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', (event: any) => resolve(event.target.result));
    reader.onerror = e => reject(e);
    reader.readAsDataURL(file);
  });
}

export function preloadImage(url: string) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

export function getThumbDataURL(url: string, onlyDimentions?: boolean, maxPixelTarget = MAX_THUMB_SIZE): Promise<{ width: number, height: number, dataUrl?: string, thumbWidth?: number, thumbHeight?: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onerror = e => reject(e);
    img.onload = (e) => {
      const thumbRatio = Math.sqrt(maxPixelTarget / (img.width * img.height));
      const thumbWidth = img.width * thumbRatio;
      const thumbHeight = img.height * thumbRatio;
      if (onlyDimentions) {
        resolve({ width: img.width, height: img.height, thumbWidth, thumbHeight})
        return;
      }
      const canvas = document.createElement("canvas");
      canvas.width = thumbWidth;
      canvas.height = thumbHeight;
      canvas.getContext("2d")?.drawImage(img, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL('image/jpeg', 0.5)
      resolve({ width: img.width, height: img.height, dataUrl, thumbWidth, thumbHeight })
    }
    // img.crossOrigin = 'anonymous'
    img.src = url;
  });

}


  /**
   * TAKEN FROM https://github.com/yoksel/url-encoder/blob/master/script.js
   * @param data UTF8 content of an SVG file
   */
  function encodeSVG(data:string):string {
    //data = data.replace(/"/g, "'");
    data = data.replace(/'/g, '"');

    data = data.replace(/>\s{1,}</g, "><");
    data = data.replace(/\s{2,}/g, " ");
    return data.replace(/[\r\n%#()<>?[\\\]^`{|}]/g, encodeURIComponent);
  }

